// The reader's own custom status beside their name in the sidebar footer (the webapp shows it
// there; the Mac shows it in the profile). Expired = absent, judged at render like every row.
import { CustomStatusCodec } from '../../../core/customStatus';
import type { UserRecord } from '../../../core/records';
import { EmojiGlyph } from '../emoji/EmojiGlyph';
import './settings.css';

export function OwnStatusEmoji({ user }: { user: UserRecord }) {
  const cs = CustomStatusCodec.fromPropsJSON(user.customStatusJSON);
  if (!cs || !CustomStatusCodec.isActive(cs, Date.now())) return null;
  return (
    <span className="me-status" title={cs.text} aria-label={cs.text}>
      <EmojiGlyph name={cs.emoji || 'speech_balloon'} />
    </span>
  );
}
